import {z} from "zod";
import {imageSchema} from "@/images/ImageSchema.ts";
import {CharacterClasses} from "@/characters/model/CharacterClasses.ts";
import {SPELL_SCHOOLS} from "@/spells/model/SpellSchools.ts";
import {Spell} from "@/spells/model/Spell.ts";
import {v4 as UUID} from "uuid";

const requiredText = (message: string) => z.string().trim().min(1, message);

export const spellSchema = z.object({
    id: requiredText("ID erforderlich"),
    name: requiredText("Name erforderlich"),
    image: imageSchema.optional(),
    school: z.enum(SPELL_SCHOOLS),
    level: z.number().int().min(0).max(9),
    classes: z.array(z.enum(CharacterClasses)).min(1, "Mindestens eine Klasse erforderlich"),
    time: requiredText("Zeitaufwand erforderlich"),
    range: requiredText("Reichweite erforderlich"),
    components: requiredText("Komponenten erforderlich"),
    duration: requiredText("Wirkungsdauer erforderlich"),
    concentration: z.boolean(),
    description: requiredText("Beschreibung erforderlich"),
    materialComponents: z.string().trim().optional(),
    ritual: z.boolean(),
    source: requiredText("Quelle erforderlich"),
});

export type SpellFormInput = z.input<typeof spellSchema>;
export type SpellFormOutput = z.output<typeof spellSchema>;

export function toSpellFormValues(spell?: Spell): SpellFormInput {
    if (!spell) return {
        id: `spell-${UUID()}`,
        name: "",
        school: "Abjuration",
        level: 0,
        classes: [],
        time: "1 Aktion",
        range: "",
        components: "V, G",
        duration: "",
        concentration: false,
        description: "",
        materialComponents: "",
        ritual: false,
        source: "",
    };

    return {
        id: spell.id,
        name: spell.name,
        image: spell.image,
        school: spell.school,
        level: spell.level,
        classes: [...spell.classes],
        time: spell.time,
        range: spell.range,
        components: spell.components,
        duration: spell.duration,
        concentration: spell.concentration,
        description: spell.description,
        materialComponents: spell.materialComponents ?? "",
        ritual: spell.ritual,
        source: spell.source,
    };
}
